// extracted by mini-css-extract-plugin
export default {"MuiBackdrop-root-two":"styles_MuiBackdrop-root-two__QO5w2"};